<div class="landing_container" [ngClass]="{ 'nl-market': isNL }">
  <section class="hero-section ha-hero">
    <div class="ha-card">
      <div class="ha-grid">
        <!-- Text / content column -->
        <div class="ha-content">
          <div class="ha-eyebrow">
            {{ 'PAGES.LANDING.LP1.EYEBROW' | translate }}
          </div>
          <h1 class="ha-title">
            {{ staticHeroText() }}
            <span
              class="ha-word"
              [@animateText]="textAnimationState()"
              (@animateText.done)="animationFinished($event)"
              >{{ dynamicHeroText() }}</span
            >
          </h1>
          <p class="ha-subtitle">
            {{ 'PAGES.LANDING.LP1.SUBTITLE' | translate }}
          </p>
          <div class="ha-cta">
            <button
              class="ha-btn-primary"
              type="button"
              (click)="externalService.goToCreateTask()"
            >
              {{ 'PAGES.LANDING.TO_BUTTON' | translate }}
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12h14"></path>
                <path d="m13 6 6 6-6 6"></path>
              </svg>
            </button>
          </div>
          <!-- Projected so the damage compensation test arm can pull the
               badge into its trust row; control renders it unchanged. -->
          <app-damage-compensation-line>
            @if (showTrustpilot()) {
              <a
                class="ha-trust"
                (click)="scrollToTrustpilot()"
                (keydown.enter)="scrollToTrustpilot()"
                role="button"
                tabindex="0"
                [attr.aria-label]="
                  'PAGES.LANDING.LP1.TRUSTPILOT_ALT' | translate
                "
              >
                <picture>
                  <source
                    media="(min-width: 831px)"
                    [srcset]="trustpilotImgMedium"
                  />
                  <img
                    [src]="trustpilotImgShort"
                    [alt]="'PAGES.LANDING.LP1.TRUSTPILOT_ALT' | translate"
                    width="800"
                    height="71"
                  />
                </picture>
              </a>
            }
          </app-damage-compensation-line>
        </div>

        <!-- Media / rotating image column -->
        <div class="ha-media">
          <div class="ha-media-frame">
            <img
              [@animateImage]="imageAnimationState()"
              (@animateImage.done)="imageAnimationFinished($event)"
              [src]="dynamicHeroImage()"
              width="350"
              height="370"
              priority
              fetchpriority="high"
              sizes="(max-width: 480px) 90vw, (max-width: 1100px) 45vw, 480px"
              [alt]="'PAGES.LANDING.HERO_IMG_ALT' | translate"
            />
            <!-- Pause Button -->
            <div class="pause-button-container">
              <button
                class="pause-button"
                (click)="toggleRotationPause()"
                [attr.aria-label]="
                  (isRotationPaused()
                    ? 'PAGES.LANDING.RESUME_ROTATION'
                    : 'PAGES.LANDING.PAUSE_ROTATION'
                  ) | translate
                "
                type="button"
              >
                <ui-icon
                  [name]="isRotationPaused() ? 'play' : 'pause'"
                  variant="stroke"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div
    class="deep-link-buttons-container-landing-page max-w-full mt-5 !px-5 outer_seo_page_component_container"
  >
    <div class="inner_seo_page_component_container">
      <app-deep-link-buttons
        [buttons]="deepLinkButtons()"
        [showScrollArrows]="true"
      />
    </div>
  </div>
  <app-service-options />
  <app-how-it-works [noButton]="true" />
  @if (showTrustpilot()) {
    <app-trustpilot-widget />
  }
  @defer (on viewport) {
    <app-review-slider />
  } @placeholder {
    <div class="task-examples-placeholder"></div>
  }
  <app-why-handyhand [isLandingPage]="true" />
  <app-meet-some-handyhands />
  <app-service-provider-value-prop />

  <app-landing-page-faq [noBorderRadius]="true"> </app-landing-page-faq>
  <div [innerHTML]="schema | jsonLd"></div>
  <app-lp-footer [greyBackground]="true" />
</div>
